import { Component } from '@verndale/core'

class Module extends Component {
  setupDefaults() {
    this.dom = {
      formSelector: this.el.querySelector('select[name="topic"]'),
      forms: [...this.el.querySelectorAll('.page-forms__form')]
    }

    if (this.dom.formSelector) {
      this.dom.formSelector.addEventListener('option', this.handleChangeForms.bind(this))
    }
  }

  handleChangeForms() {
    const value = this.dom.formSelector.value;
    this.dom.forms.forEach(form => {
      if (form.dataset.form === value) {
        form.classList.add('is-open');
      } else {
        form.classList.remove('is-open');
      }
    })
  }
}

export default Module;
